"use client";
import { getCookie } from "@workspace/cookies/browser";
import hasLogoutParam from "./auth/hasLogoutParam";
import getSiteInfo from "./components/LinkComponent/helpers/getSiteInfo";
import setHeader from "./fetchGraphqlServer/setHeader";
import toJson from "./fetchGraphqlServer/toJson";

type FetchResult<Mutation> = {
  data?: Mutation;
  error?: "unauthorized" | "generic" | "exception";
};

const fetchGraphqlClient = async <
  Mutation,
  Variables = Record<string, unknown>,
>(
  query: string,
  mutationName: string,
  options?: { variables?: Variables },
): Promise<FetchResult<Mutation>> => {
  const url = `${location.origin}/graphql`;
  const { variables } = options ?? {};
  const token = getCookie("token");
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify({ query, variables }),
    redirect: "follow",
    headers: {
      ...setHeader(`Authorization`, token, () => `Bearer ${token}`),
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    const isUnauthorized = response.status === 401 && !!token;

    if (
      isUnauthorized &&
      !hasLogoutParam(location.search) &&
      !location.pathname.includes("/login")
    ) {
      const { pathPrefix } = getSiteInfo();
      window.location.href = `${pathPrefix || "/"}?forceLogout=1`;
    }

    return {
      data: undefined,
      error: isUnauthorized ? "unauthorized" : "generic",
    };
  }
  try {
    return toJson<Mutation>(response);
  } catch (error) {
    console.error("fetchGraphqlClient error:", mutationName, error);
    return { data: undefined, error: "exception" };
  }
};

export default fetchGraphqlClient;
